import api from ".";
import { getToken } from "../Auth/Token";

export const syncErpagProducts = async () => {
  try {
    const token = getToken();
    const res = await api.post("/api/products/sync-erpag", {}, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Sync ERPAG Products Error:", error);
    throw error;
  }
};


export const getProducts = async () => {
  try {
    const token = getToken(); 
    const res = await api.get("/api/workOrder/getProducts", {
      headers: {
         Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Products API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getAssignedProducts = async () => {
  try {
    const token = getToken();

    const res = await api.get("/api/workOrder/products-with-levels", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return {
      success: true,
      count: res.data.count || res.data.data?.length || 0,
      data: res.data.data || [],
      message: res.data.message || "Assigned products fetched successfully",
    };
  } catch (error) {
    console.error("getAssignedProducts API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      url: "/api/workorders/products-with-levels",
    });

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Failed to load configured products";

    throw new Error(errorMessage);
  }
};

export const getDetailedSkuProducts = async () => {
  try {
    const token = getToken();

    const res = await api.get("/api/products/detailed-sku-products", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return {
      count: res.data.count || res.data.products?.length || 0,
      products: res.data.products || [],
    };
  } catch (error) {
    console.error("getDetailedSkuProducts API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      url: "/api/products/detailed-sku-products",
    });
    throw error;
  }
};

export const getAssignProductivityLevel = async () => {
  try {
    const token = getToken(); 
    const res = await api.get("/api/workOrder/getAssignProductivityLevel", {
      headers: {
         Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Assign Productivity Level API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const assignProductivityLevel = async (productivityData) => {
  try {
    const token = getToken(); 
    const res = await api.post(
      "/api/workOrder/assignProductivityLevel",
      productivityData,
      {
        headers: {
           Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Assign Productivity Level API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getAssignCleaningLevel = async () => {
  try {
    const token = getToken(); 
    const res = await api.get("/api/workOrder/getAssignCleaningLevel", {
      headers: {
         Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Assign Cleaning Level API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const assignCleaningLevel = async (cleaningData) => {
  try {
    const token = getToken(); 
    const res = await api.post(
      "/api/workOrder/assignCleaningLevel",
      cleaningData,
      {
        headers: {
           Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Assign Cleaning Level API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getAssignMachineToolLevel = async () => {
  try {
    const token = getToken(); 
    const res = await api.get("/api/workOrder/getAssignMachineToolLevel", {
      headers: {
         Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Assign Machine Tool Level API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const assignMachineToolLevel = async (machineToolData) => {
  try {
    const token = getToken(); 
    const res = await api.post(
      "/api/workOrder/assignMachineToolLevel",
      machineToolData,
      {
        headers: {
           Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Assign Machine Tool Level API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const updateProduct = async (productData) => {
  try {
    const token = getToken(); 
    const res = await api.put("/api/workOrder/updateProduct", productData, {
      headers: {
         Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Update Product API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const searchSkuProducts = async (sku) => {
  try {
    const token = getToken();

    const res = await api.post(
      "/api/products/search-skus",
      {
        sku,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return {
      count: res.data.count || res.data.products?.length || 0,
      products: res.data.products || [],
    };
  } catch (error) {
    console.error("getDetailedSkuProducts API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      url: "/api/products/search-skus",
      sku,
    });
    throw error;
  }
};

export const saveSkuProducts = async (newSkus, familyId, family) => {
  try {
    const token = getToken();

    // If newSkus comes from react-select, it might be an array of objects.
    // We need to ensure it's an array of strings for the backend.
    const skuStrings = newSkus.map(item => 
      typeof item === 'string' ? item : item.value
    );

    // Prepare the payload correctly
    const payload = { 
      id: familyId, 
      name: family.name, 
      skus: skuStrings // Send only the strings ["0012345", "5849120001"]
    };

    // Correct Axios-style call: api.post(URL, DATA, CONFIG)
    const res = await api.post("/api/products/save-skus", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });

    return res.data;
  } catch (error) {
    console.error("saveSkuProducts API Error:", error.response?.data || error.message);
    throw error;
  }
};

export const removeSkuProducts = async (familyId, updatedFamily) => {
  try {
    const token = getToken();

    // If newSkus comes from react-select, it might be an array of objects.
    // We need to ensure it's an array of strings for the backend.
    const skuStrings = updatedFamily?.skus?.map(item => 
      typeof item === 'string' ? item : item.value
    );

    // Prepare the payload correctly
    const payload = { 
      id: familyId, 
      skus: skuStrings // Send only the strings ["0012345", "5849120001"]
    };

    // Correct Axios-style call: api.post(URL, DATA, CONFIG)
    const res = await api.post("/api/products/remove-skus", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });

    return res.data;
  } catch (error) {
    console.error("saveSkuProducts API Error:", error.response?.data || error.message);
    throw error;
  }
};